<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.admin.mst.group.title.list') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          {{ $t('message.admin.mst.group.desc.list.text1') }}
        </div>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="6" md="3" class="py-0">
        <mp-button min wide @click="goAdd">{{ $t('message.admin.mst.group.button.toAdd') }}</mp-button>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          item-key="groupLargeId"
          :headers="headers"
          :items="view.groupList"
          locale="jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          hide-default-footer
          mobile-breakpoint=0
          disable-pagination
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody>
            <template v-for="groupLarge in items">
              <tr v-for="(groupSmall, index) in groupLarge.groupSmallList" :key="groupLarge.groupLargeName.ja + index">
                <td v-if="index === 0"
                    :rowspan="groupLarge.groupSmallList.length"
                    class="no-hover"
                >{{ groupLarge.groupLargeName.ja }}
                </td>
                <td>
                  <router-link :to="'/admin/mst/group/detail/' + groupSmall.groupSmallId">
                    {{ groupSmall.groupSmallName.ja }}
                  </router-link>
                </td>
                <td align="center">{{ groupSmall.displayOrder }}</td>
              </tr>
            </template>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpButton from '@/components/item/MpButton.vue'
import { Common } from '@/api'

export default {
  components: {
    MpButton
  },
  data: () => ({
    view: {
      groupList: []
    },
    form: {}
  }),
  computed: {
    headers () {
      return [
        { text: i18n.t('message.admin.mst.group.headers.groupLargeName'), value: 'groupLargeName', sortable: false, width: '40%' },
        { text: i18n.t('message.admin.mst.group.headers.groupSmallName'), value: 'groupSmallName', sortable: false, width: '50%' },
        { text: i18n.t('message.admin.mst.group.headers.displayOrder'), align: 'center', value: 'displayOrder', sortable: false, width: '10%' }
      ]
    }
  },
  methods: {
    goAdd () {
      // アカウント追加画面へ遷移
      this.$router.push({ path: '/admin/mst/group/add' })
    }
  },
  mounted: async function () {
    this.view.groupList = await Common.groupList()
  }
}
</script>

<style scoped>
  td.no-hover {
    background-color: #FFFFFF
  }

  button {
    width: 100%;
  }
</style>
